import { SecurityOptions } from "./types";


export const defaultSecurityOptions: SecurityOptions = {
  CSRF: true,
};

/** default timeout of 10 seconds */
export const DEFAULT_API_TIMEOUT_IN_MS = 10000;


export const mobileMappingStatus = {
  GUEST_OR_INVALID: "0",
  VERIFIED: "1",
  MULTIPLE_OR_NO_MOBILE_FOUND: "2",
  MOBILE_FOUND: "3",
  MOBILE_FOUND_BUT_LINKED: "4",
  UNVERIFIED: "5",
};

export enum STATUS_CODE {
  CART_NOT_FOUND = "003",
  ADDRESS_NOT_SERVICEABILITY_FASHION = "028",
  ADDRESS_NOT_SERVICEABILITY_BEAUTY = "032"
}
